import ArticleCard from "@src/app/components/ArticleCard";
import NewsletterSignUp from "@src/app/components/NewsletterSignUp";
import SectionContainer from "@src/app/components/SectionContainer/SectionContainer";
import { useRouteResponse } from "@src/app/hooks/useRouteResponse";
import { createMetaTags } from "@src/app/utils/createMetaTags";

import { fetchReginalPageData } from "./Regional.server";

export const loader = fetchReginalPageData;

export const meta = () => {
  return createMetaTags({
    title: "Regional News & Opinions with a China focus | ThinkChina",
    description:
      "Regional - Get latest insights on China through the eyes of global thought leaders & journalists.",
    canonical: `https://www.thinkchina.sg/regional`,
    ogInfo: {
      ogTitle: "Regional News & Opinions with a China focus | ThinkChina",
      ogDescription:
        "Regional - Get latest insights on China through the eyes of global thought leaders & journalists.",
    },
  });
};

export default function RegionalPage() {
  const route = useRouteResponse("regionalPage");
  const regional = route.regional;

  return regional.map((item, index) => {
    const more = item.articles?.length ? item.tagUrlPath : undefined;

    return (
      <SectionContainer title={item.title} key={item.title} more={more}>
        <div>
          {item.banner ? (
            <div className="px-3 py-4">
              <img src={item.banner} alt={item.title} />
            </div>
          ) : null}

          <div className="grid grid-cols-12">
            {(item.articles || []).map((article) => {
              return (
                <ArticleCard
                  key={article.id}
                  article={article}
                  className="col-span-12 lg:col-span-4"
                />
              );
            })}
          </div>
        </div>

        {index === 0 ? <NewsletterSignUp variant="regional" withIcon /> : null}
      </SectionContainer>
    );
  });
}
